module.exports = __webpack_public_path__ + "static/media/cusat.ae25beee.png";